(function () {
	const headerMobile = () => {
		const headerSection = document.querySelector(".header-mobile-section");
		const header = document.querySelector(".header-mobile");
		const burger = document.querySelector(".header-mobile__burger");
		const closeButton = document.querySelector(".punk-mobile-close-button");
		const mobileMenu = document.querySelector(".header-mobile__menu");
		const mobileAnimateBg = document.querySelector(".animate-bg");

		if (!headerSection || !header || !burger || !closeButton || !mobileMenu || !mobileAnimateBg) {
			return;
		}

		const setMenuState = (isOpen) => {
			header.classList.toggle("mobile-menu-open", isOpen);
			mobileMenu.classList.toggle("active", isOpen);
			mobileAnimateBg.classList.toggle("active", isOpen);
			document.body.classList.toggle("overflow-hidden", isOpen);

			burger.classList.remove("active");
			burger.setAttribute("aria-expanded", isOpen ? "true" : "false");
		};

		setMenuState(false);

		let scrollPos = 0;

		window.addEventListener("scroll", () => {
			if (!header.classList.contains("sticky-header")) {
				return;
			}

			const scroll = window.scrollY;

			if (scroll > 40) {
				header.classList.add("header-scroll");
			} else {
				header.classList.remove("header-scroll");
			}

			if (scroll > scrollPos) {
				if (scroll > 100 && !header.classList.contains("sticky-header-always")) {
					headerSection.classList.add("hide");
				}
			} else {
				headerSection.classList.remove("hide");
			}

			scrollPos = scroll;
		});

		burger.addEventListener("click", function (e) {
			e.preventDefault();
			setMenuState(true);
		});

		closeButton.addEventListener("click", function (e) {
			e.preventDefault();
			setMenuState(false);
		});

		let resizeTimeout;

		window.addEventListener("resize", () => {
			clearTimeout(resizeTimeout);

			resizeTimeout = setTimeout(() => {
				if (window.innerWidth >= 1100) {
					setMenuState(false);
				}
			}, 300);
		});
	};

	document.addEventListener("shopify:section:load", headerMobile);
	headerMobile();
})();